import useLoadingOverlayInlineStyles from './UseLoadingOverlayInlineStyles';
import useLoadingOverlayStyles from './UseLoadingOverlayStyles';

export {
	useLoadingOverlayInlineStyles,
	useLoadingOverlayStyles,
};